﻿import { IEmailSendeeContract } from './email-sendee-contract';

export interface IEmailSendeeRequestContract {
    emailTemplateId: number;
    sendee: IEmailSendeeContract;
}
